var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 120,
    viewBox: "0 0 640 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_variant_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M61 9V91.122L13 112V29.8784L61 9Z",
    fill: "#DEBC7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.8,
    d: "M157 9V91.122L109 112V29.8784L157 9Z",
    fill: "#DEBC7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    opacity: 0.9,
    d: "M61 9V91.122L109 112V29.8784L61 9Z",
    fill: "#DEBC7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    opacity: 0.7,
    d: "M157 9V91.122L205 112V29.8784L157 9Z",
    fill: "#DEBC7C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "RUTA",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.64 69.9999V91.9999H278.76V32.3999H300.92C304.973 32.3999 308.56 33.1332 311.68 34.5999C314.8 36.0666 317.24 38.1866 319 40.9599C320.76 43.7332 321.64 47.1466 321.64 51.1999C321.64 55.3066 320.666 58.7999 318.72 61.6799C316.773 64.5599 314.146 66.6932 310.84 68.0799L324.52 91.9999H312.2L299.88 69.9999H289.64ZM289.64 60.3999H301.08C304.013 60.3999 306.36 59.5599 308.12 57.8799C309.88 56.1999 310.76 53.9732 310.76 51.1999C310.76 48.3732 309.88 46.1332 308.12 44.4799C306.36 42.8266 304.013 41.9999 301.08 41.9999H289.64V60.3999ZM382.6 92.9599C387.186 92.9599 391.253 91.9999 394.8 90.0799C398.346 88.1599 401.133 85.5199 403.16 82.1599C405.186 78.7999 406.2 74.9866 406.2 70.7199V32.3999H395.32V70.1599C395.32 72.6666 394.773 74.8932 393.68 76.8399C392.586 78.7866 391.093 80.3066 389.2 81.3999C387.306 82.4932 385.106 83.0399 382.6 83.0399C380.146 83.0399 377.96 82.4932 376.04 81.3999C374.12 80.3066 372.613 78.7866 371.52 76.8399C370.426 74.8932 369.88 72.6666 369.88 70.1599V32.3999H359V70.7199C359 74.9866 360.013 78.7999 362.04 82.1599C364.066 85.5199 366.853 88.1599 370.4 90.0799C373.946 91.9999 378.013 92.9599 382.6 92.9599ZM466.6 41.9999V91.9999H455.64V41.9999H440.2V32.3999H481.8V41.9999H466.6ZM519.32 91.9999L523.64 79.1999H546.68L550.92 91.9999H562.76L542.2 32.3999H528.12L507.56 91.9999H519.32ZM535.16 44.4799L526.76 69.5999H543.56L535.16 44.4799Z",
    fill: "#DEBC7C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWide);
export default __webpack_public_path__ + "static/media/logo_wide.37ab3f7e95cbcf2aeb8b068fae38a90b.svg";
export { ForwardRef as ReactComponent };